import React from 'react';

import { kebabCase } from 'lodash-es';

import { Text } from '@change/ds-core-ui';

type Props = Readonly<{
	name: string;
	title: string;
	description: string;
}>;

export const TaskTextContent: React.FC<Props> = ({ name, title, description }) => (
	<>
		<Text data-qa={`task-title-${kebabCase(name)}`} variant="body" className="text-size-body-bold" as="p">
			{title}
		</Text>
		<Text
			data-qa={`task-description-${kebabCase(name)}`}
			variant="body"
			size="small"
			className="text-typography-weak"
			as="p"
		>
			{description}
		</Text>
	</>
);
